import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import React, { FC } from 'react';

import '../styles/_tabNav.scss';

interface TabLinks {
	name: string;
	path: string;
	display?: boolean | string;
}

type TableSelectionProps = {
	selection: string;
	tabNavLinks: TabLinks[];
};

export const TabNav: FC<TableSelectionProps> = (props) => {
	const { selection, tabNavLinks } = props;
	const theme: any = useTheme();

	return (
		<div className='tabNavSelections'>
			{tabNavLinks.map((link) => {
				const isActive = selection === link.path;

				return (
					<Link
						style={{
							...(isActive
								? {
										color: 'white',
										backgroundColor: theme.sidebar.backgroundColor,
									}
								: {
										color: 'black',
									}),
						}}
						className='tabNavSelection'
						key={link.name}
						href={link.path}
						target='_self'
					>
						{link.name}
					</Link>
				);
			})}
		</div>
	);
};
